export const baseTooltipStyle = {
    fontSize: '12px',
    fontFamily: 'Verdana, sans-serif',
};
